module.exports = __webpack_public_path__ + "img/real_maps_overlay.60102ab4.png";